import React, { FC, useMemo, useState } from 'react';
import { useParams } from 'react-router';

import { useAuth } from 'context/auth';
import { TabPanel } from 'devextreme-react';

import { ComingNomenclatureTransport, ComingNomenclatureWrapper, History } from './components';

const itemTitleRender = (tab: { name: string; index: number }) => {
  return <span>{tab.name}</span>;
};

const ComingNomenclatureDetail: FC = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [selectedIndex, setSelectedIndex] = useState<number>(0);
  let { id } = useParams<{ id: string }>();
  const { getClaims }: any = useAuth();

  const isCanShowHistory = getClaims(['CanLookCashFlowHistories']);

  const tabs = useMemo(
    () => [
      {
        name: 'Основная информация',
        index: 0,
      },
      {
        name: 'Список машин',
        index: 1,
        visible: !!id,
      },
      {
        name: 'История изменений',
        index: 2,
        visible: !!id && isCanShowHistory,
      },
    ],
    [id, isCanShowHistory],
  );

  return (
    <div>
      <TabPanel
        height="auto"
        dataSource={tabs}
        selectedIndex={selectedIndex}
        onOptionChanged={(e) => {
          if (e.name === 'selectedIndex') {
            setSelectedIndex(e.value);
          }
        }}
        itemTitleRender={itemTitleRender}
        animationEnabled={false}
        onSelectionChanged={(e) => setActiveTab(e.addedItems![0].index)}
      />
      {activeTab === 0 && (
        <div className="tab-content">
          <ComingNomenclatureWrapper />
        </div>
      )}
      {activeTab === 1 && (
        <div className="tab-content">
          <ComingNomenclatureTransport />
        </div>
      )}
      {activeTab === 2 && (
        <div className="tab-content">
          <History />
        </div>
      )}
    </div>
  );
};

export default ComingNomenclatureDetail;
